import React from 'react';
import './reviews.css';
import ReviewCard from './review-card';

const reviews = ({ reviews }) => {
    return (
        <div className="mt-2">
            <p className="f-36 mb-4 me-2 mt-3 poly">Reviews</p>
            <div className="reviews-section">
                <div className="reviews-container">
                    <div className="pe-2">
                        {!reviews || reviews.length === 0 ? (
                            <p className="poppins text-center text-muted py-4">This business has no reviews yet.</p>
                        ) : (
                            reviews?.map((item, idx) => (
                                <div key={idx}>
                                    <ReviewCard item={item} />
                                    {idx + 1 !== reviews?.length && (
                                        <hr className="my-4 review-hr" />
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reviews;
